import { httpClient } from './http-client';
const newsBackendPrefix = '/api/news';

export default {
	getNews(params) {
		return httpClient.get(newsBackendPrefix, { params });
	},
	getTags() {
		return httpClient.get(newsBackendPrefix + '/tags');
	}
};
